const processInclude = require('sfraScripts/util');
$(document).ready(function () {
	processInclude(require('./product/details'));
	processInclude(require('./product/viewItemEvent'));
	processInclude(require('./customSelect'));
	processInclude(require('./product/tabSticky'));
	// processInclude(require('./product/addToCartPdp'));
});

processInclude(require('./components/spinner'));
